import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'
import { useCropsContext } from '~/common/context/crops/crops-context'

/**
 * Fetches all reports for a farm, re-fetching whenever the crops context
 * refreshKey changes (which increments on reportAdded / reportUpdated).
 *
 * @param {Object} params
 * @param {string} params.farmId - Farm organization ID
 * @returns {{ reports: Array }} Array of report objects with joined report_types
 */
export const useReportsByFarm = ({ farmId }) => {
  const [reports, setReports] = useState([])
  const { refreshKey } = useCropsContext()

  useEffect(() => {
    if (!farmId) {
      setReports([])
      return
    }

    supabaseGetter.reports.getByOrganization(farmId).then(({ data }) => {
      setReports(data || [])
    })
  }, [farmId, refreshKey])

  return { reports }
}
